/* eslint-disable no-inline-styles/no-inline-styles */
import React from 'react';

export default function MobileLayoutWrapper(props: React.PropsWithChildren<{}>) {
    return (
        <div className={'width-100 flex'}>
            <div
                className={'flex-column width-100 padding-16 padding-top-0 relative gap-32'}
                style={{
                    minHeight: 'calc(100vh - 40px - env(safe-area-inset-bottom, 0) - 10)', // 100vh - header - safe area - padding
                }}
            >
                {props.children}
            </div>
        </div>
    );
}
